// i18n 中英双语
export const translations = {
  en: {
    appTitle: 'Selfie Vault',
    login: { title: 'Selfie Vault', subtitle: 'Enter password to continue', placeholder: 'Password', submit: 'Enter', error401: 'Wrong password', error429: 'Too many attempts, try later', err: 'Login failed' },
    header: { refresh: 'Refresh', logout: 'Log out', trash: 'Trash', select: 'Select', cancel: 'Cancel', lang: 'Language', theme: 'Theme', storage: 'Storage', menu: 'Menu', back: 'Back' },
    tab: { all: 'All', image: 'Photos', video: 'Videos', trash: 'Trash' },
    empty: { title: 'No photos yet', hint: 'Click the button below to start', photo: 'Take photo', file: 'Choose file', drag: 'Drag & drop', subtitle: 'Tap the + button or drag files here' },
    stats: { used: 'Used', files: 'Files', quota: 'Quota' },
    ops: { download: 'Download', delete: 'Delete', restore: 'Restore', permanent: 'Permanently delete', close: 'Close', selectAll: 'Select all', clear: 'Clear', upload: 'Upload' },
    bulk: { selected: 'selected', download: 'Download', delete: 'Delete', cancel: 'Cancel' },
    confirm: { deleteTitle: 'Delete {{n}} file(s)?', deleteBody: 'Will move to trash, auto-purged after 30 days.', move: 'Move to trash', deleteOne: 'Delete file', cancel: 'Cancel', perma: 'Permanently delete {{n}} file(s)? This cannot be undone. Type "delete" to confirm.', typeDelete: 'Type "delete" to confirm' },
    lightbox: { slide: 'Slideshow', download: 'Download', delete: 'Delete' },
    upload: { preparing: 'Preparing...', uploading: 'Uploading', done: 'Upload complete', failed: 'Upload failed', resume: 'Resume', pause: 'Pause', retry: 'Retry', queued: 'Waiting', offline: 'Offline - paused', resumed: 'Resumed' },
    detail: { res: 'Resolution', takenAt: 'Taken', size: 'Size', format: 'Format', duration: 'Duration', uploadedAt: 'Uploaded' },
    theme: { dark: 'Dark', light: 'Light' },
    lang: { zh: '中文', en: 'English' },
  },
  zh: {
    appTitle: 'Selfie Vault',
    login: { title: 'Selfie Vault', subtitle: '输入密码进入', placeholder: '密码', submit: '进入', error401: '密码错误', error429: '尝试过多,稍后再试', err: '登录失败' },
    header: { refresh: '刷新', logout: '登出', trash: '回收站', select: '选择', cancel: '取消', lang: '语言', theme: '主题', storage: '空间利用率', menu: '菜单', back: '返回' },
    tab: { all: '全部', image: '图片', video: '视频', trash: '回收站' },
    empty: { title: '还没有照片', hint: '点击下方按钮开始', photo: '拍照', file: '选择文件', drag: '拖拽', subtitle: '点击 + 按钮或拖拽文件到这里' },
    stats: { used: '已用', files: '文件数', quota: '总配额' },
    ops: { download: '下载', delete: '删除', restore: '恢复', permanent: '永久删除', close: '关闭', selectAll: '全选', clear: '清除', upload: '上传' },
    bulk: { selected: '已选', download: '下载', delete: '删除', cancel: '取消' },
    confirm: { deleteTitle: '删除 {{n}} 个文件?', deleteBody: '将移到回收站,30 天后自动清理。', move: '移到回收站', deleteOne: '删除文件', cancel: '取消', perma: '永久删除 {{n}} 个文件? 不可恢复。输入 "删除" 确认。', typeDelete: '输入 "删除" 确认' },
    lightbox: { slide: '幻灯片', download: '下载', delete: '删除' },
    upload: { preparing: '准备中...', uploading: '上传中', done: '上传完成', failed: '上传失败', resume: '继续', pause: '暂停', retry: '重试', queued: '等待中', offline: '离线 - 已暂停', resumed: '已恢复' },
    detail: { res: '分辨率', takenAt: '拍摄时间', size: '大小', format: '格式', duration: '时长', uploadedAt: '上传时间' },
    theme: { dark: '深色', light: '浅色' },
    lang: { zh: '中文', en: 'English' },
  },
} as const;

export type Lang = 'en' | 'zh';
export type TKey = keyof typeof translations['en'];

// 轻量 t() 函数 (不用完整 i18n 库, 减少体积)
export function makeT(lang: Lang) {
  const dict = translations[lang] ?? translations.en;
  return function t(key: string, vars?: Record<string, string | number>): string {
    // 支持 dot path: login.submit
    const parts = key.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let cur: any = dict;
    for (const p of parts) {
      if (cur == null) break;
      cur = cur[p];
    }
    let str = typeof cur === 'string' ? cur : key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        str = str.replace(new RegExp('{{' + k + '}}', 'g'), String(v));
      }
    }
    return str;
  };
}

// 返回当前语言 (localStorage 或浏览器)
export function detectLang(): Lang {
  const saved = localStorage.getItem('sv_lang');
  if (saved === 'en' || saved === 'zh') return saved;
  const nav = navigator.language || '';
  return nav.startsWith('zh') ? 'zh' : 'en';
}

export function setLang(lang: Lang) {
  localStorage.setItem('sv_lang', lang);
}